import { DropdownItemInterface } from '../interfaces/dropdown-item-interface';

export class DropdownItemModel implements DropdownItemInterface {
  label: any;
  translatedLabel?: string;
  value: any;
  phonePrefix?: string;

  constructor(init?: Partial<DropdownItemModel>) {
    Object.assign(this, init);
  }
}
